export const CAR_MODEL = {
  Amarok: 'amarok',
  Touareg: 'touareg',
  Buzz: 'Buzz',
};
